import { useContext } from 'react';
import { BillingContext } from '../../context/BillingContext';

/** SRS #57: the matters module speaks "legal" on law-firm / enterprise segments and "consulting" everywhere else. */
export interface Wording { legal: boolean; module: string; unit: string; units: string; deliverable: string; deliverables: string; question: string; internal: string; signoff: string; lockMessage: string; titleLabel: string; leadLabel: string; openAction: string }
/** Names no plan on purpose.
 *
 *  This used to read "part of the Professional plan and above", which stopped
 *  being true when the agreed four-tier structure moved client matters to
 *  Growth — so the lock screen was telling a customer to buy a plan that does
 *  not include the feature. The plan a customer actually needs is computed
 *  from the catalogue and arrives in the 403 (`feature_locked.upgrade_to`),
 *  which is what the page shows whenever it has it; this is only the fallback
 *  for a refusal that carried no message, and a fallback must not hard-code a
 *  commercial fact that lives in an admin-editable table. */
const LOCKED = 'Client matters and briefs are not part of your current plan';

export const wordingFor = (segment: string | null | undefined): Wording => {
  const legal = segment === 'law_firm' || segment === 'enterprise';
  return legal
    ? { legal, module: 'Client matters', unit: 'matter', units: 'matters', deliverable: 'memo', deliverables: 'Legal memoranda', question: 'Question presented', internal: 'Internal (privileged)', signoff: 'Lawyer sign-off — freezes the memo', lockMessage: LOCKED, titleLabel: 'Matter title', leadLabel: 'Responsible lawyer', openAction: 'Open matter' }
    : { legal, module: 'Client engagements', unit: 'engagement', units: 'engagements', deliverable: 'brief', deliverables: 'Advisory briefs', question: 'Purpose of the brief', internal: 'Internal (confidential)', signoff: 'Consultant sign-off — freezes the brief', lockMessage: LOCKED, titleLabel: 'Engagement title', leadLabel: 'Responsible consultant', openAction: 'Open engagement' };
};
export function useWording(): Wording {
  const billing = useContext(BillingContext);   // null outside the provider (tests): consulting wording
  return wordingFor(billing?.entitlements?.segment);
}
